import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfilesService } from '@kitch/data-access/services';
import { Product } from '@kitch/ui/models';

@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
})
export class MarketplaceComponent {
  readonly products$ = this.getAllProducts();

  constructor(private profileService: ProfilesService) { }

  trackByFn(index: number, product: Product): string {
    return product.id;
  }

  private getAllProducts(): Observable<Product[]> {
    return this.profileService.getAllProducts();
  }
}
